import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import HandymanHero from './components/HandymanHero';
import HandymanServices from './components/HandymanServices';
import CommonProjects from './components/CommonProjects';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import HandymanFAQ from './components/HandymanFAQ';

export default function HandymanPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      <main>
        <HandymanHero />
        <HandymanServices />
        <CommonProjects />
        <ContractorDirectory />
        <ComparisonChecklist />
        <HandymanFAQ />
      </main>
      <Footer />
    </div>
  );
}
